module.exports = __webpack_public_path__ + "img/rec-13.b0abae04.png";